import { UserDefaultIcon } from '@practium/ui';

export const consultantFarmersChartData = [
	{ month: '01', realizado: 12, anoAnterior: 10 },
	{ month: '02', realizado: 13, anoAnterior: 12 },
	{ month: '03', realizado: 14, anoAnterior: 13 },
	{ month: '04', realizado: 14, anoAnterior: 15 },
	{ month: '05', realizado: 16, anoAnterior: 15 },
	{ month: '06', realizado: 17, anoAnterior: 16 },
	{ month: '07', realizado: 16, anoAnterior: 17 },
	{ month: '08', realizado: 17, anoAnterior: 17 },
	{ month: '09', realizado: 18, anoAnterior: 18 },
	{ month: '10', realizado: 18, anoAnterior: 19 },
	{ month: '11', realizado: 19, anoAnterior: 19 },
	{ month: '12', realizado: 20, anoAnterior: 20 },
];

export const consultantFarmersChartConfig = {
	title: 'Crescimento de Clientes',
	mainValue: '18 Agricultores',
	trendValue: '12.5%',
	trendLabel: 'vs ano anterior',
	trendDirection: 'up' as const,
	footerText: 'Agricultores ativos de Jan-Dez, 2025',
	buttonText: 'Ver Relatório',
	onButtonClick: () => {},
	xAxisKey: 'month',
	bar1Key: 'realizado',
	bar1Label: 'Realizado',
	bar2Key: 'anoAnterior',
	bar2Label: 'ano anterior',
};

export const consultantAnalysisTypeDonutData = [
	{ name: 'Solo', value: 28, color: 'var(--chart-donut-dark)' },
	{ name: 'Foliar', value: 15, color: 'var(--chart-donut-medium)' },
	{ name: 'Água', value: 2, color: 'var(--chart-donut-light)' },
];

export const consultantAnalysisTypeDonutConfig = {
	title: 'Análises por Tipo',
	subtitle: 'Distribuição de serviços',
	buttonText: 'Ver Relatório',
	onButtonClick: () => {},
};

export const consultantRecommendationsChartData = [
	{ name: 'Geradas', value: 32 },
	{ name: 'Em Implementação', value: 18 },
	{ name: 'Concluídas', value: 24 },
];

export const consultantRecommendationsChartConfig = {
	title: 'Recomendações Agronômicas',
	subtitle: 'Status das orientações técnicas',
	buttonText: 'Ver Relatório',
	onButtonClick: () => {},
};

export const consultantTopFarmersData = [
	{ id: 1, name: 'João Silva', value: '8 análises', icon: UserDefaultIcon },
	{ id: 2, name: 'Maria Santos', value: '6 análises', icon: UserDefaultIcon },
	{ id: 3, name: 'Pedro Costa', value: '5 análises', icon: UserDefaultIcon },
	{ id: 4, name: 'Ana Oliveira', value: '4 análises', icon: UserDefaultIcon },
];

export const consultantTopFarmersConfig = {
	title: 'Agricultores Mais Ativos',
	subtitle: 'Clientes com mais análises',
	buttonText: 'Ver Relatório',
	onButtonClick: () => {},
};

export const consultantActivityLineData = [
	{ day: '01', current: 28, previous: 34 },
	{ day: '02', current: 32, previous: 25 },
	{ day: '03', current: 35, previous: 28 },
	{ day: '04', current: 30, previous: 43 },
	{ day: '05', current: 38, previous: 30 },
	{ day: '06', current: 42, previous: 30 },
];

export const consultantActivityLineConfig = {
	title: 'Atendimentos Realizados',
	mainValue: '205 Atendimentos',
	trendValue: '15.8%',
	trendLabel: 'vs semana anterior',
	trendDirection: 'up' as const,
	footerText: 'Atendimentos de 1-6 Dez, 2025',
	buttonText: 'Ver Relatório',
	onButtonClick: () => {},
	xAxisKey: 'day',
	line1Key: 'current',
	line1Label: 'Semana Atual',
	line2Key: 'previous',
	line2Label: 'Semana Anterior',
	tooltipTitle: 'Atendimentos',
};
